// eslint-disable-next-line jira/filename-case
import React from 'react';
import { usePlacementSSRFetch } from '@jira/post-office__post-office-provider-preload-placement/src/preload-placement.tsx';
import { PlacementFetchingProvider } from '@atlassian/post-office-placement-data/placement-fetcher-provider';
import type { RouteResource } from '@atlassian/react-resource-router';

export const PlacementFetchProvider: React.FC<{
	children: React.ReactNode;
	resource: RouteResource;
}> = ({ children, resource }) => {
	const fetch = usePlacementSSRFetch(resource);

	return <PlacementFetchingProvider fetch={fetch}>{children}</PlacementFetchingProvider>;
};
